export const Mocks = {
	menuResponseMockSTG: require('./data_menu_STG.json'),
	menuResponseMockPROD: require('./data_menu_PROD.json'),
	bannersResponseMockSTG: require('./data_banners_STG.json'),
	bannersResponseMockPROD: require('./data_banners_PROD.json'),
	tradInBannersResponseMockSTG: require('./data_tradein_banners_STG.json'),
	tradInBannersResponseMockPROD: require('./data_tradein_banners_PROD.json'),
};
